export const CheckoutValidationCode = Object.freeze({
  None: 0,
  DuplicateBooking: 1,
  ClassNotInFuture: 2,
});
